import ProfileComponent from "@/Component/Profile";

const ProfilePage = () => {
    return (
        <ProfileComponent />
    );
}

export default ProfilePage;
